import { useTheme } from '@mui/material';
import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingOverlay = ({ isLoading, showContent }) => {
  const theme = useTheme();
  
  return isLoading ? (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent overlay
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000, // Ensure overlay is on top
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
        }}
      >
        <CircularProgress
          sx={{
            color: theme.palette.primary.main,
            marginBottom: 2,
          }}
        />
        <Typography
          sx={{
            color: theme.palette.primary.contrastText,
            fontSize: theme.typography.h6.fontSize,
          }}
        >
          {showContent}
        </Typography>
      </Box>
    </Box>
  ) : null;
};

export default LoadingOverlay